import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';
import { Entities } from '../Enums/Entities.enum';
import { FileServiceProviderType } from '../Enums/FileServiceProviderType.enum';

import { FspConfigUnion } from './FspConfigUnion.entity';
import { OneDriveFspConfig } from './OneDriveFspConfig.entity';
import { WebDavFspConfig } from './WebDavFspConfig.entity';

export class FileServiceProviderConfig<T extends EMode = EMode.entity> {
  /** Alias: id */
  id?: string;
  /** Alias: name */
  name?: string;
  /** Alias: providerType */
  providerType?: FileServiceProviderType;
  /** Alias: isWorkDirectory */
  isWorkDirectory?: boolean;
  /** Alias: directoryConvertPaths */
  directoryConvertPaths?: string[];
  /** Alias: config */
  config?: T extends EMode.query
    ? FspConfigUnion<T>
    : OneDriveFspConfig<T> | WebDavFspConfig<T>;

  __typename?: string;
}

const fields: FieldDefinitions<FileServiceProviderConfig> = {
  id: {
    alias: 'id',
  },
  name: {
    alias: 'name',
  },
  providerType: {
    alias: 'providerType',
  },
  isWorkDirectory: {
    alias: 'isWorkDirectory',
  },
  directoryConvertPaths: {
    alias: 'directoryConvertPaths',
  },
  config: {
    alias: 'config',
    entity: [Entities.oneDriveFspConfig, Entities.webDavFspConfig],
  },
  __typename: {
    alias: '__typename',
  },
};

export const fileServiceProviderConfigEntityDefinition: EntitiyDefinition<FileServiceProviderConfig> =
  {
    local: {},
    remote: {
      queryName: 'getFileServiceProvider',
      fragmentName: 'FileServiceProviderConfig',
      withPaginationWrapper: false,
      mutations: {
        upsert: {
          mutationName: 'upsertFileServiceProvider',
          args: [{ name: 'input', type: 'InputFileServiceProviderConfig!' }],
        },
      },
    },
    fieldDefinitions: fields,
  };
